import script from "./ModalAvisoPersona.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAvisoPersona.vue?vue&type=script&setup=true&lang=js"

import "./ModalAvisoPersona.vue?vue&type=style&index=0&id=6dde01be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dde01be"]])

export default __exports__